// extracted by mini-css-extract-plugin
export default {"headshot":"amazonLogo-module__headshot__JuxEo"};